import axios from '@axios';
import moment from 'moment';
// eslint-disable-next-line import/named
import { getDayOfWeekStringFromDate } from '@/util/helpers';

const base = '/api/v1/prisons/';
const baseWings = '/api/v1/wings/';
const baseBookingSlots = '/api/v1/booking-slots';

export default {
  getPrison(prisonId) {
    return axios.get(`${base}single-prison/${prisonId}`)
  },
  getPrisonWings() {
    return axios.get(`${baseWings}mdm-user`);
  },
  getBookingSlotAvailability(prisonId) {
    return axios.get(`${baseBookingSlots}/availability/prison/${prisonId}`);
  },
  getBookingSlotAvailabilityForWing(prisonId, wingId) {
    return axios.get(`${baseBookingSlots}/availability/prison/${prisonId}/${wingId}`);
  },
  getLastDateFromBookingSlot(slots) {
    let date = null;

    slots.forEach(slot => {
      const stockAll = slot.stock;

      stockAll.forEach(stock => {
        if (date === null || moment(stock.date).isAfter(date)) { // if date is null or date is older then set date
          date = stock.date;
        }
      });
    });
    return date;
  },
  getAvailableBookingSlots(slots, bookingDate) {
    const slotAv = [];
    const day = getDayOfWeekStringFromDate(bookingDate);

    slots.forEach(slot => {
      const stockAll = slot.stock;
      let pushed = false;
      stockAll.forEach(stock => {
        if (stock.remaining > 0 && slot.day_of_week === day && !pushed) {
          slotAv.push(slot);
          pushed = true;
        }
      });
    });

    return slotAv;
  },
};
